<template>
	<div>
		<p v-if="label" class="pb-2 text-sm text-text-secondary">{{ label }}</p>
		<div class="flex items-center gap-3">
			<AppIconContained v-if="icon" :icon :variant :palette />
			<router-link v-if="linkTo" :to="linkTo" class="hover:underline">
				<span>{{ value }}</span>
			</router-link>
			<span v-else>{{ value }}</span>
		</div>
	</div>
</template>

<script lang="ts" setup>
import type { RouteLocationRaw } from "vue-router";

interface Props {
	icon?: string;
	label?: string;
	value: string;
	variant?: "square" | "circle";
	palette?: "purple" | "gray" | "red";
	linkTo?: RouteLocationRaw;
}
withDefaults(defineProps<Props>(), {
	variant: "square",
	palette: "gray",
});
</script>
